/* eslint-disable import/prefer-default-export */

import { httpRequest } from 'utils';

export const setContactUsAction = async (contactUs) => {
  httpRequest('/api/contact', 'post', contactUs, { 'Content-Type': 'application/json' })
    .catch(() => false);
};
